import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function TermsOfUse() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <section className="relative py-20 md:py-24 bg-background-50">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-600 transition-colors cursor-pointer whitespace-nowrap mb-10"
            >
              <i className="ri-arrow-left-line"></i>
              返回主頁
            </button>

            <div className="mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100/80 text-secondary-800 text-xs font-semibold tracking-widest uppercase mb-6 whitespace-nowrap">
                <i className="ri-file-list-3-line"></i>
                Terms of Use · 使用條款
              </div>
              <h1 className="font-heading text-3xl md:text-4xl font-medium text-foreground-950 leading-tight">
                使用條款及免責聲明
              </h1>
              <p className="mt-2 text-sm text-foreground-500">
                最後更新日期：2026 年 7 月 24 日
              </p>
            </div>

            <div className="space-y-8 text-sm md:text-base text-foreground-700 leading-[1.8]">
              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  1. 網站宗旨與內容性質
                </h2>
                <p>
                  <strong className="text-foreground-900">1mindlab</strong>（以下稱「本網站」）係一個專注於心靈療癒、正念啟發與大自然連結嘅內容分享平台。我哋透過網誌文章、每日智慧卡、抱樹療癒資訊等多元內容，為現代人提供心靈層面嘅溫柔支持與日常啟發。
                </p>
                <p className="mt-2">
                  本網站所有文章均由原創團隊用心撰寫，內容圍繞心靈覺醒、自我療癒、正念生活同大自然療癒等主題，旨在分享正向觀點與實用心靈工具。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  2. 非醫療免責聲明（Medical Disclaimer）
                </h2>
                <p>
                  本網站所提供之所有內容，包括但不限於心靈分享、療癒訊息、心情配對建議、抱樹指引及每日智慧卡，
                  <strong className="text-foreground-900">僅供個人心靈放鬆及日常參考之用</strong>，並不構成任何專業心理學、精神科醫學診斷、治療建議或醫療處方。
                </p>
                <p className="mt-2">
                  如你正面對嚴重嘅心理健康問題、持續性情緒困擾、自殘或自殺念頭，請務必尋求合資格嘅專業醫療人員或註冊心理學家協助。本網站內容絕對不能替代專業醫療診斷或治療。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  3. 資訊準確性
                </h2>
                <p>
                  我哋會盡力確保本網站所載資訊之準確性與時效性，但唔對內容之完整性、準確性或適用性作出任何明示或暗示之保證。用戶應自行判斷內容之適用性，並承擔使用本網站資訊之風險。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  4. 第三方連結
                </h2>
                <p>
                  本網站可能包含前往第三方網站（包括但不限於 Instagram、YouTube、Google 及合作夥伴網站）之連結。該等網站擁有獨立嘅條款同私隱政策，本網站不對其內容、服務或資料處理方式負責。建議用戶在離開本網站後，細閱相關第三方之條款。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  5. 知識產權
                </h2>
                <p>
                  本網站所有內容（包括文字、圖片、標誌、設計及原始碼）均受版權法保護，未經 1mindlab 書面同意，不得擅自複製、轉載、修改或作商業用途。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  6. 用戶行為
                </h2>
                <p>
                  用戶使用本網站時，即代表同意自行承擔相關風險，並承諾不會利用本網站進行任何非法、欺詐、騷擾或損害第三方權益之行為。本網站保留因用戶不當行為而終止其使用權限之權利。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  7. 條款修訂
                </h2>
                <p>
                  本網站保留隨時修改本使用條款之權利。任何重大變更將於本頁面公佈，並更新「最後更新日期」。建議用戶定期查閱本頁，以確保了解最新版本之內容。用戶在條款修訂後繼續使用本網站，即代表接受修訂後之條款。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  8. 聯絡我們
                </h2>
                <p>
                  如對本使用條款有任何疑問，歡迎透過本網站「聯絡我們」頁面與我哋聯絡，電郵地址為{' '}
                  <a
                    href="mailto:1mindlabhugtree@gmail.com"
                    className="font-medium text-primary-600 hover:text-primary-700 underline underline-offset-4 decoration-primary-300 transition-colors"
                  >
                    1mindlabhugtree@gmail.com
                  </a>
                  。
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}